<template>
    <component v-if="userAllowedImportExport" :is="componentName">
    </component>

    <NoImportExportPermission v-else>
    </NoImportExportPermission>
</template>


<script>
import NoImportExportPermission from '@/views/landingpages/NoImportExportPermission.vue';
import LegacyExport from './LegacyExport.vue';
import ExportModern from './ExportModern.vue';

export default {
    name: 'ExportWrapper',
    props: {},
    components: {
        NoImportExportPermission,
        LegacyExport,
        ExportModern,
    },
    mixins: [],

    data() {
        return {};
    },

    methods: {},

    computed: {
        ModernExportEnabled() {
            return this.$store.state.GlobalSettings?.Features?.ModernExportEnabled;
        },

        componentName() {
            return this.ModernExportEnabled ? 'ExportModern' : 'LegacyExport';
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>